/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { Button, Icon, Radio } from '@scuf/common';
import { useTranslation } from '@scuf/localization';
import React, { useContext } from 'react';
import { ApiContext } from '../../../../context/ApiContext';
import descriptors from '../../../../locales/en-US/descriptors';
import {
  IManualFileUploadType,
  MAGIC_VALUE,
  ManualFileUploadTypeList
} from '../../../shared/Utils/Constants';

function ChooseDataTypeTab(props: {
  selectedDataType: string;
  onSelectDataType: Function;
}) {
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  const { selectedDataType, onSelectDataType } = props;
  const apiContext = useContext(ApiContext);
  const { onTemplateDownloadClick } = apiContext;
  const selectedTypeObject = ManualFileUploadTypeList.find(
    (x) => x.type === selectedDataType
  );
  return (
    <div className="ChooseDataTypeTab">
      <div className="ptb-20 fw-400 text-color">
        {t(d.CHOOSEDATATYPEMESSAGE)}
      </div>
      <div>
        <div className="full-width pb-10 fw-500">{t(d.DATATYPE)}</div>
        {ManualFileUploadTypeList.map((value: IManualFileUploadType) => (
          <Radio
            key={`upload-radio-${value.type}`}
            disabled={value.disabled}
            className="full-width"
            label={value.name}
            name="datatypeSelection"
            checked={selectedDataType === value.type}
            onChange={() => {
              onSelectDataType(value.type);
            }}
          />
        ))}
      </div>
      <div className="ptb-10 flex">
        <Icon root="building" name="document" size="medium" />
        <div className="plr-5">
          <Button
            type="link"
            className="download-csv-button"
            content={`Download ${selectedTypeObject?.downloadText} CSV Template`}
            onClick={() => {
              if (onTemplateDownloadClick)
                onTemplateDownloadClick(
                  selectedDataType,
                  selectedTypeObject?.allowedFiles[0].downloadFile || '',
                  selectedTypeObject?.allowedFiles[0].uploadType || ''
                );
            }}
          />
        </div>
      </div>
      <div>
        <span className="fw-400 text-color">
          {t(d.FILEUPLOADNOTE, {
            type: selectedTypeObject?.allowedFiles[0].type,
            size: selectedTypeObject
              ? selectedTypeObject.allowedFiles[0].maxSize /
                MAGIC_VALUE.MEGABYTES
              : MAGIC_VALUE.FIFTY
          })}
        </span>
      </div>
    </div>
  );
}

export default ChooseDataTypeTab;
